// extracted by mini-css-extract-plugin
export default {"searchPageWrapper":"searchPageStyles_searchPageWrapper__P8pUp"};